// DEV: anytime you need to use the actions-set-nav component update as needed

export default {
	FORM: 'form',
	CUSTOMER_ERROR_LOGS: 'customer-error-logs',
	INTEGRATION_MANAGER: 'integration-manager',
	VENDOR_SETTINGS: 'vendorSettings',
	TRANSACTIONS: 'transactions',
	VENDOR_HISTORY: 'vendorHistory'
};
